import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          ListGroup,
          ListGroupItem,
          Image,
          Radio} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
import GoogleMapReact from 'google-map-react';
import UsersService from "../../services/users-service";
import ToursService from "../../services/tours-service";
import UtilsService from "../../services/utils-service";
import QRCode from 'qrcode.react';
import { saveAs } from 'file-saver';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';

import PostOrder from "./post-order";
import EmailNotif from "./email-notif";
// import MapMaker from './mapMaker.js'

import _ from "underscore";
import $ from "jquery";
import moment from 'moment';
var map;
var onChangeTimeOut;
//props
//facilities
//facilityLocations
class TourManage extends Component {

  constructor(props, context) {
      super(props, context);
      this.state = {
          selectedLocations: [],
          facilityLocations: [],
          newPostOrder: {name: "", additional: {
                                        type: "none",
                                        value: null,//Only for radio
                                        options:
                                          {description: "",
                                            choices: [{name: "Choice 1", value: false},
                                                      {name: "Choice 2", value: false},]
                                          }}
                                        },
          newEmailNotif: [{email: "email", sendTime: "0:00 AM"}],
      }
      this.renderLocationList = this.renderLocationList.bind(this);
      this.renderSchedule = this.renderSchedule.bind(this);
      this.renderPostOrders = this.renderPostOrders.bind(this);
      this.renderLocationDetails = this.renderLocationDetails.bind(this);

      this.onChangeSchedule = this.onChangeSchedule.bind(this);
      this.onChangePostOrder = this.onChangePostOrder.bind(this);
      this.onChangeEmailNotif = this.onChangeEmailNotif.bind(this);
      this.addPostOrder = this.addPostOrder.bind(this);
      this.deletePostOrder = this.deletePostOrder.bind(this);
      this.addEmailNotif = this.addEmailNotif.bind(this);
      this.deleteEmailNotif = this.deleteEmailNotif.bind(this);
  }

  render() {
    return (<Row md={12} style={{margin: 10}}>
              <Col md={4}>
                  {this.renderLocationList()}
              </Col>
              {this.renderLocationDetails()}
           </Row>)
  }

  componentDidMount() {

  }

  renderLocationList() {
    var facilityLocations = this.state.facilityLocations;
    return (<Row>
              <Col style={{height: 600, overflowY: "scroll"}}>
                  <FormGroup style={{textAlign: "center", borderRadius: 5, marginTop: "3%", width: "100%", paddingLeft: 20}}>
                  <ControlLabel className="login_label">Facility</ControlLabel>
                      <FormControl  componentClass="select"
                                    style={{width: "90%"}}
                                    value={this.state.facility ? this.state.facility : ""}
                                    onChange={(e)=>{
                                        var newSelectedLocations = this.state.selectedLocations.slice();
                                        var newState = {
                                                          facility: e.target.value,
                                                          selectedLocations: [],
                                                          checkAllLocations: false,
                                                        };
                                        newSelectedLocations.map((location, i)=>{
                                          newState[i+"_"+location.location_name+"_isActive"] = false;
                                        });

                                        this.setState(newState);

                                        ToursService.sharedInstance.getFacilityLocationsByFacilityId(this.props.getRecnoForName(e.target.value, "Facility"))
                                                    .then((response)=>{
                                                      this.setState({
                                                                      facilityLocations: response,
                                                                    })
                                                    });

                                      }}>
                                    {this.renderDropDowns("Facility", this.props.facilities, "facility_name")}
                      </FormControl>
                  </FormGroup>
                  <Row className="pull-left" style={{marginBottom: "50", borderBottom: "thin solid #000000", width: "100%"}}>
                    <Col md={12}>
                      <Checkbox checked={this.state["checkAllLocations"] ? this.state["checkAllLocations"] : false}
                                style={{paddingLeft: 20, width: "100%", right: "0%"}}
                                onChange={()=>{
                                    var isChecked = this.state["checkAllLocations"];
                                    var newState = {};
                                    newState["checkAllLocations"] = !isChecked;
                                    var newSelectedLocations = facilityLocations.slice()
                                    newSelectedLocations.map((location, i)=>{
                                      newState[i+"_"+location.location_name+"_isActive"] = newState.checkAllLocations;
                                    });
                                    newState["selectedLocations"] = newSelectedLocations.slice();

                                    this.setState(newState)
                                }}>{"Select All Locations"}
                      </Checkbox>
                    </Col>
                  </Row>
                  <Row>
                  <ListGroup>
                  {facilityLocations.map((location, i) => {
                    if(location.is_active == 1)
                      return <ListGroupItem key={location.location_name +"_"+i}
                                style={{padding: 0, width: "100%", flexDirection: "row", justifyContent: "flex-start", textAlign: "left", flex: 1}}
                                className="pull-left">
                                  <Row style={{}}>

                                      <Col md={9}style={{}}>
                                        <Checkbox checked={this.state[i+"_"+location.location_name+"_isActive"] ? this.state[i+"_"+location.location_name+"_isActive"] : false}
                                                  style={{paddingLeft: 20, width: "100%"}}
                                                  onChange={()=>{
                                                      var isChecked = this.state[i+"_"+location.location_name+"_isActive"];
                                                      var newState = {};
                                                      var newSelectedLocations = this.state.selectedLocations.slice()

                                                      if(!isChecked) {
                                                        newState[i+"_"+location.location_name+"_isActive"] = true;
                                                        newSelectedLocations.push(location);
                                                      } else {
                                                        newSelectedLocations.splice(newSelectedLocations.indexOf(location), 1);
                                                        newState["checkAllLocations"] = false;
                                                        newState[i+"_"+location.location_name+"_isActive"] = false;
                                                      }
                                                      newState["selectedLocations"] = newSelectedLocations.slice();

                                                      this.setState(newState)
                                                  }}>
                                                  {location.location_name}
                                        </Checkbox>
                                      </Col>

                                      <Col md={2} className="pull-left" style={{}}>
                                      <Glyphicon glyph="download-alt"
                                              style={{cursor: "pointer", marginTop: 10, paddingRight: 10}}
                                              onClick={()=>{
                                                ToastStore.warning("Download under construction!");
                                              }}/>

                                      </Col>

                                  </Row>
                              </ListGroupItem>
                    })}
                  {facilityLocations == null || facilityLocations.length <=0
                      ? <ListGroupItem key={"NoLocation"}
                          style={{padding: 0, width: "100%", flexDirection: "row", justifyContent: "flex-start", textAlign: "left", flex: 1}}
                          className="pull-left">
                            <Row style={{textAlign: "center"}}>
                              <Col>
                              No Locations
                              </Col>


                            </Row>
                        </ListGroupItem>
                      : null}

                  </ListGroup>
                  </Row>
              </Col>
            </Row>);
  }

  renderLocationDetails() {
    if(this.state.selectedLocations.length <= 0) {
        return <Col md={8} style={{paddingTop: "20%"}}> Select Facility Location/s to Start </Col>
    } else if(this.validLocations(this.state.selectedLocations)) {
      return <Col md={8}>
                  {this.renderSchedule()}
                  {this.renderPostOrders()}
                  {this.renderEmailNotifs()}
                  <Row style={{marginTop: 40,}}>
                    <Col md={11} style={{textAlign: "center", fontSize: 25, color: "#1A404A", bold: true}}>{"QR Codes"}</Col>
                  </Row>
                  {this.renderHiddenQRCodes()}
                  <Row>
                    <Button className="dark-blue-btn pull-right"
                      onClick={(e)=>{
                        //use JSZip to download. it's in npmjs site
                        this.onDownloadQR(e.target);
                      }}>
                      Download QR Codes
                    </Button>
                  </Row>
              </Col>
    } else {
        return <Col md={8} style={{paddingTop: "20%"}}>  Location Conflicts!</Col>
    }

  }

  renderSchedule() {
    var itemSched =  [];
    try{
       itemSched =  this.state.selectedLocations.length > 0 && this.state.selectedLocations[0].schedules
                            ? JSON.parse(this.state.selectedLocations[0].schedules)
                            : [];
    }
    catch(e){

    }

    var days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    return (<Row style={{padding: 10, backgroundColor: "#f7f7f9"}}>
              <Col>
                <Row>
                  <Col md={11} style={{textAlign: "left", fontSize: 25, color: "#1A404A", bold: true}}>{"SCHEDULE"}</Col>
                  <Col md={1} style={{justifyContent: "flex-end"}}>{"Any"}</Col>
                </Row>
                {days.map((day, i)=>{
                    return <Row key={i} style={{paddingTop: 10, paddingBottom: 10}}>
                                <Col md={1} style={{textAlign: "center", paddingLeft: 10}}>{day}</Col>
                                <Col md={2}>
                                    <Datetime
                                          inputProps={{readOnly: true}}
                                          dateFormat={false}
                                          timeFormat={"h:mm A"}
                                          value={itemSched[i] && itemSched[i].constructor === Array
                                                    ? itemSched[i][0]
                                                      ? itemSched[i][0]
                                                      : ""
                                                    : itemSched[i] != null
                                                      ? "Any"
                                                      : ""}
                                          onChange={(e)=>{
                                          this.onChangeSchedule(0, i, e.format("h:mm A"));
                                        }}/>
                                </Col>
                                <Col md={2}>
                                  <Datetime
                                        inputProps={{readOnly: true}}
                                        dateFormat={false}
                                        timeFormat={"h:mm A"}
                                        value={itemSched[i] && itemSched[i].constructor === Array
                                                  ? itemSched[i][1]
                                                    ? itemSched[i][1]
                                                    : ""
                                                  : itemSched[i] != null
                                                    ? "Any"
                                                    : ""}
                                        onChange={(e)=>{
                                          this.onChangeSchedule(1, i, e.format("h:mm A"));
                                      }}/>
                                </Col>
                                <Col md={2}>
                                  <Datetime
                                        inputProps={{readOnly: true}}
                                        dateFormat={false}
                                        timeFormat={"h:mm A"}
                                        value={itemSched[i] && itemSched[i].constructor === Array
                                                  ? itemSched[i][2]
                                                    ? itemSched[i][2]
                                                    : ""
                                                  : itemSched[i] != null
                                                    ? "Any"
                                                    : ""}
                                        onChange={(e)=>{
                                            this.onChangeSchedule(2, i, e.format("h:mm A"));
                                      }}/>
                                </Col>
                                <Col md={2}>
                                  <Datetime
                                        inputProps={{readOnly: true}}
                                        dateFormat={false}
                                        timeFormat={"h:mm A"}
                                        value={itemSched[i] && itemSched[i].constructor === Array
                                                  ? itemSched[i][3]
                                                    ? itemSched[i][3]
                                                    : ""
                                                  : itemSched[i] != null
                                                    ? "Any"
                                                    : ""}
                                        onChange={(e)=>{
                                            this.onChangeSchedule(3, i, e.format("h:mm A"));
                                      }}/>
                                </Col>
                                <Col md={2}>
                                  <Datetime
                                        inputProps={{readOnly: true}}
                                        dateFormat={false}
                                        timeFormat={"h:mm A"}
                                        value={itemSched[i] && itemSched[i].constructor === Array
                                                  ? itemSched[i][4]
                                                    ? itemSched[i][4]
                                                    : ""
                                                  : itemSched[i] != null
                                                    ? "Any"
                                                    : ""}
                                        onChange={(e)=>{
                                            this.onChangeSchedule(4, i, e.format("h:mm A"));
                                      }}/>
                                </Col>
                                <Col md={1}>
                                    <Checkbox inline
                                              checked={itemSched[i] === "Any"}
                                              onChange={()=>{
                                                this.toggleAny(i, itemSched[i])
                                              }}></Checkbox>
                                </Col>
                            </Row>
                  })}
              </Col>
            </Row>);
  }

  renderPostOrders() {
    var facilityLocations = this.state.selectedLocations.slice();
    var postOrders = [];

    if(facilityLocations[0].post_orders != null) {
      var tempOrders =  JSON.parse(facilityLocations[0].post_orders);
      tempOrders.map((tempOrder, tempOrderIndex)=>{
        postOrders.push(this.renderPostOrder(tempOrder, tempOrderIndex+1))
      })
    }

    var postOrdersX = [
                      {name: "Eat", additional: {
                                                    type: "checkbox",
                                                    value: null,//Only for radio
                                                    options:
                                                      {description: "Check Windows",
                                                        choices: [{name: "Front Window", value: false},
                                                                  {name: "Side Window", value: false},
                                                                  {name: "Back Door", value: false},
                                                                  {name: "Side Alley", value: false}]
                                                      }}
                                                    },
                        {name: "Chair Himos", additional: {
                                                      type: "radio",
                                                      value: "Stacked",
                                                      options:
                                                        {description: "Chair conditions",
                                                          choices: [{name: "Stacked", value: false},
                                                                    {name: "Not Stacked", value: false}]
                                                        }}
                                                      }
                     ];


    return (<Row style={{padding: 10, backgroundColor: "#f7f7f9", marginTop: 25}}>
              <Col>
                <Row>
                  <Col md={11} style={{textAlign: "left", fontSize: 25, color: "#1A404A", bold: true}}>{"POST ORDERS"}</Col>
                </Row>
                {
                  postOrders
                }
                { this.renderPostOrder(this.state.newPostOrder, null)}

              </Col>
            </Row>);
  }

  renderEmailNotifs() {
    var facilityLocations = this.state.selectedLocations.slice();
    var emailNotifs = [];
    var tempNotifs = [];

    if(facilityLocations[0].emailNotifs != null) {

      tempNotifs =  JSON.parse(facilityLocations[0].emailNotifs);

      tempNotifs.map((tempNotif, tempNotifIndex)=>{
        emailNotifs.push(this.renderEmailNotif(tempNotif, tempNotifIndex))
      })
    }

    //For testing================================//
    tempNotifs = [{email: "test email", sendTime: "0:00 AM"},
                        {email: "test email2", sendTime: "3:33 AM"}];

    console.log("tempNotifs: ", tempNotifs);
    tempNotifs.map((tempNotif, tempNotifIndex)=>{
      emailNotifs.push(this.renderEmailNotif(tempNotif, tempNotifIndex))
    })
    //==================================================//
    return (<Row style={{padding: 10, backgroundColor: "#f7f7f9", marginTop: 25}}>
              <Col>
                <Row>
                  <Col md={11} style={{textAlign: "left", fontSize: 25, color: "#1A404A", bold: true}}>{"Email Notification"}</Col>
                </Row>
                {
                  emailNotifs
                }
                { this.renderEmailNotif(this.state.newEmailNotif, null)}

              </Col>
            </Row>);
  }

  renderPostOrder(postOrder, index) {
    return <PostOrder
                key={index}
                onChangePostOrder={this.onChangePostOrder}
                postOrder={postOrder}
                postOrderIndex={index}
                addPostOrder={this.addPostOrder}
                deletePostOrder={this.deletePostOrder}/>

  }

  renderEmailNotif(emailNotif, index) {

    return <EmailNotif
                key={index}
                onChangeEmailNotif={this.onChangeEmailNotif}
                emailNotif={emailNotif}
                emailNotifIndex={index}
                addEmailNotif={this.addEmailNotif}
                deleteEmailNotif={this.deleteEmailNotif}/>

  }

  renderPostOrderChoices(choices, type, postOrderIndex, facilityLocationIndex, isNew) {

    var colors = ["blue", "pink"];//for debugging
    if(type === "checkbox") {
      return choices.map((choice, i) => {
        return <Col md={4} key={i} style={{ marginLeft: 0}}>
                    <Row style={{}}>
                      <Col md={1}>
                        <Checkbox inline disabled
                                  checked={choice.value ? choice.value : false}
                                  onChange={()=>{

                                  }}>
                          </Checkbox>
                      </Col>
                      <Col md={9} style={{}}>
                          <input type="text" style={{width: "100%", marginTop: 5}}
                            value={choice.name ? choice.name : "No Name"}
                            onChange={(e)=>{
                              e.stopPropagation();

                              if(isNew) {//if in Add New Post Order
                                var newPostOrder = this.state.newPostOrder;
                                newPostOrder["name"] = e.target.value;
                                this.setState({
                                  newPostOrder: newPostOrder
                                });
                              } else {
                                //edit
                              }

                          }}/>
                      </Col>
                      <Glyphicon glyph="trash" className="pull-left col"
                              style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                              onClick={()=>{
                                ToastStore.warning("Delete under construction!");
                              }}/>

                    </Row>
                </Col>
      })
    } else if (type === "radio") {
      return choices.map((choice, i) => {
        return <Col md={4} key={i} style={{ marginLeft: 0}}>
                    <Row style={{}}>
                      <Col md={1}>
                        <Radio name={"groupOptions_"+postOrderIndex}  disabled
                          value={choice.name}
                          onChange={(e)=>{}}></Radio>
                      </Col>
                      <Col md={9} style={{}}>
                          <input type="text" style={{width: "100%", marginTop: 5}}
                            value={choice.name ? choice.name : "No Name"}
                            onChange={(e)=>{
                              e.stopPropagation();
                              if(isNew) {
                                var newPostOrder = this.state.newPostOrder;
                                newPostOrder["name"] = e.target.value;
                                this.setState({
                                  newPostOrder: newPostOrder
                                });
                              } else {
                                //edit
                              }

                          }}/>
                      </Col>
                      <Glyphicon glyph="trash" className="pull-left col"
                              style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                              onClick={()=>{
                                ToastStore.warning("Delete under construction!");
                              }}/>

                    </Row>
                </Col>
        });
    }
  }

  renderHiddenQRCodes() {
    var selectedLocations = this.state.selectedLocations;
    var codes = [];

    selectedLocations.map((selectedLocation, i)=>{
        codes.push(<Col md={3} key={i} className="HpQrcode" style={{display: "block", backgroundColor:null, width: 240, padding: 20}} name={selectedLocation.location_name}>
                      <Row>
                            <Image className="menu-logo" fluid="true" src={require('../../assets/login_logo.png')}/>
                      </Row>
                      <QRCode size={180} value={selectedLocation.facility_location_id} />
                      <Row>{selectedLocation.location_name}</Row>
                    </Col>)
    });

    return <Row id="qrCodePage" style={{ backgroundColor: null}}>{codes}</Row>
  }

  renderDropDowns(type, list, valueAttribute) {
    var choices = [];
    if(list != null) {
      var itemList = list.slice();

      if(valueAttribute == null) {
        valueAttribute = "name";
      }
      if(itemList.length > 1) {
        choices.push(<option disabled key={"placeholder"} value={""}>Select {type}</option>);
        itemList.map((item, index) => {
                                  choices.push(<option key={index} value={item[valueAttribute]}>{item[valueAttribute]}</option>)
                                });
      } else {
        choices.push(<option key={"placeholder"} disabled value={""}>No Options</option>);
      }
    }


    return choices;
  }

  onChangeSchedule(index, parentIndex, value) {

    var newSelectedLocations = this.state.selectedLocations.slice();
    var schedules = null;

    try{
      schedules = newSelectedLocations[0].schedules
                                    ? JSON.parse(newSelectedLocations[0].schedules)
                                    : [["", "", "", "","",],
                                        ["", "", "", "","",],
                                        ["", "", "", "","",],
                                        ["", "", "", "","",],
                                        ["", "", "", "","",],
                                        ["", "", "", "","",],
                                      ["", "", "", "","",]];

      if(index != null ) {
        if(schedules[parentIndex] === "Any") {
          schedules[parentIndex] = ["","","","",""];//re-initialize sched list
        } else {
          if(typeof(schedules[parentIndex]) == "undefined"){
               schedules[parentIndex] = [];
          }
          schedules[parentIndex][index] = value;
        }
      } else {
        schedules[parentIndex] = value;
      }
    }
    catch(e){
      schedules = [];
    }

    // newSelectedLocations.map((location) => {
    //
    //   schedules = location.schedules
    //                         ? JSON.parse(location.schedules)
    //                         : [[],[],[],[],[],[],[]];
    //   if(index != null ) {
    //     if(schedules[parentIndex] === "Any") {
    //       schedules[parentIndex] = ["","","","",""];//re-initialize sched list
    //       console.log("reinit from ANY, index: ", index);
    //     } else {
    //       schedules[parentIndex][index] = value;
    //     }
    //
    //   } else {
    //     schedules[parentIndex] = value;
    //   }
    //   console.log("schedules: ", schedules);
    //   location.schedules = JSON.stringify(schedules);
    //
    // })


    //Add focus() on involved field (if editing text)
    if(onChangeTimeOut != null) {
      clearTimeout(onChangeTimeOut);
    }

    onChangeTimeOut = setTimeout(()=>{
      var ids = newSelectedLocations.map((loc)=>{return loc.facility_location_id});
      ToursService.sharedInstance.saveSchedules(ids, schedules)
                  .then((response)=>{});

      //======Delete this once API is ready, refetch locations========//
      // this.setState({
      //   selectedLocations: newSelectedLocations
      // })
      //======================//
      //Add API here
    }, 200);
  }

  onChangePostOrder(postOrder, postOrderIndex) {

    //if postOrderIndex is null, assume newPostOrder
    let newSelectedLocations = this.state.selectedLocations.slice();
    let newFacilityLocation = null;
    let finalLocations = [];

    let newPostOrders = [];

    if(postOrderIndex != null) {

      if(newSelectedLocations && newSelectedLocations.length > 0) {
        newPostOrders = newSelectedLocations[0].post_orders ? JSON.parse(newSelectedLocations[0].post_orders) : [];
        newPostOrders.push(postOrder);
        this.savePostOrders(newPostOrders);
      }

    } else {
      this.setState({
        newPostOrder: postOrder
      })
    }
  }

  onChangeEmailNotif(emailNotif, emailNotifIndex) {
    //if postOrderIndex is null, assume newPostOrder
    let newSelectedLocations = this.state.selectedLocations.slice();
    let newFacilityLocation = null;
    let finalLocations = [];

    let newEmailNotifs = [];

    if(emailNotifIndex != null) {

      if(newSelectedLocations && newSelectedLocations.length > 0) {
        newEmailNotifs = newSelectedLocations[0].email_notifs ? JSON.parse(newSelectedLocations[0].email_notifs) : [];
        newEmailNotifs.push(emailNotif);
        this.saveEmailNotifs(newEmailNotifs);
      }

    } else {
      this.setState({
        newEmailNotif : emailNotif
      })
    }
  }

  onDownloadQR() {
    const canvases =  $(".HpQrcode");//$(".HpQrcode > canvas");
    var zip = new JSZip();
    var itemsToWait = canvases.length;
      canvases.each((index, rawCanvas)=>{
        html2canvas(rawCanvas)
        .then((canvas)=>{
          canvas.toBlob((blob)=>{
            itemsToWait--;
            zip.file($(rawCanvas).attr("name")+"_"+index+".png", blob);
            if(itemsToWait <= 0) {
              zip.generateAsync({type : "blob"})
              .then((blob)=>{
                saveAs(blob, "qrCodes.zip");
              });
            }
          });
        })

      })
  }

  deletePostOrder(postOrderIndex) {
    let selectedLocations = this.state.selectedLocations.slice();
    let newSelectedLocations = [];

    if(selectedLocations && selectedLocations.length > 0 && postOrderIndex - 1 < selectedLocations.length) {
        let newPostOrders = JSON.parse(selectedLocations[0].post_orders);
        newPostOrders.splice(postOrderIndex-1, 1);
        this.savePostOrders(newPostOrders);
    }

  }

  addPostOrder(newPostOrder) {
    var newSelectedLocations = this.state.selectedLocations.slice();
    var newFacilityLocation = null;
    var finalLocations = [];
    var newPostOrders = [];

    if(newSelectedLocations && newSelectedLocations.length > 0) {
      newPostOrders = newSelectedLocations[0].post_orders ? JSON.parse(newSelectedLocations[0].post_orders) : [];
      newPostOrders.push(newPostOrder);
      newPostOrders = newPostOrders;
    }
    this.savePostOrders(newPostOrders);

  }

  deleteEmailNotif(emailNotifIndex) {
    ToastStore.warning("Delete function under construction!");
  }

  addEmailNotif(emailNotif) {
    ToastStore.warning("Add function under construction!");
  }

  toggleAny(parentIndex, any) {
    var index = 0;
    if(any === "Any") {
      while(index <= 4) {
        this.onChangeSchedule(index, parentIndex, "");
        index++;
      }
    } else {
      while(index <= 4) {
        this.onChangeSchedule(null, parentIndex, "Any");
        index++;
      }
    }

  }

  validLocations(locations) {
    //uses a reference postOrders, then compares it to the rest of the selected.
    //if at least one does not match the reference, it would be invalid
    var reference = locations[0].post_orders;//postOrders would be stringified fresh out of db
    var validLocations = true;
    var index = 0;

    while (index < locations.length && validLocations) {
      if( reference !== locations[index].post_orders) {
        validLocations = false;
      }
      index++;
    }

    return validLocations;
  }

  updateSelectedLocations() {

          ToursService.sharedInstance.getFacilityLocationsByFacilityId(this.props.getRecnoForName(this.state.facility, "Facility"))
                      .then((response)=>{

                        let selectedLocations = this.state.selectedLocations.slice();
                        let finalSelectedLocations = [];

                        selectedLocations.map((selectedLocation)=>{
                          let newLoc = _.find(response, (loc)=>{return loc.facility_location_id === selectedLocation.facility_location_id});

                          if(newLoc) {
                            finalSelectedLocations.push(newLoc);
                          }
                        })
                        console.log("ToursService response: ", response);
                        this.setState({
                                        selectedLocations: finalSelectedLocations,
                                        facilityLocations: response,
                                      })
                      });
  }

  savePostOrders(newPostOrders) {
    let newSelectedLocations = this.state.selectedLocations.slice();
    let ids = newSelectedLocations.map((newSelectedLocation)=>{
      return newSelectedLocation.facility_location_id
    });
    ToursService.sharedInstance.savePostOrders(ids, newPostOrders)
    .then((response)=>{
      this.setState({newPostOrder: {name: "", additional: {
                                    type: "none",
                                    value: null,//Only for radio
                                    options:
                                      {description: "",
                                        choices: [{name: "Choice 1", value: false},
                                                  {name: "Choice 2", value: false},]
                                      }}
                                    }
                      }, ()=>{this.updateSelectedLocations();});

    })
    .catch((e)=>{
      console.log("Error: ", e);
    })
  }

  saveEmailNotifs(newEmailNotifs) {
    let newSelectedLocations = this.state.selectedLocations.slice();
    let ids = newSelectedLocations.map((newSelectedLocation)=>{
      return newSelectedLocation.facility_location_id
    });
    console.log("Saving in progress: ", newEmailNotifs);
    // ToursService.sharedInstance.saveEmailNotifs(ids, newEmailNotifs)
    // .then((response)=>{
    //   this.setState({newEmailNotifs: [{name: "", additional: ""}]
    //                   }, ()=>{this.updateSelectedLocations();});
    //
    // })
    // .catch((e)=>{
    //   console.log("Error: ", e);
    // })
  }
}

export default TourManage;
